var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarpool({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_397",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29229",
    "data-name": "Group 29229",
    transform: "translate(657 10575)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -657, -10575)",
    filter: "url(#Ellipse_397)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_397-2",
    "data-name": "Ellipse 397",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_9_",
    "data-name": "svgexport-17 (9)",
    transform: "translate(-636 -10557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50450",
    "data-name": "Path 50450",
    d: "M65.746,157.638a.9.9,0,0,1-.752-.4l-3.846-5.83a.9.9,0,1,1,1.5-1l3.846,5.83a.9.9,0,0,1-.751,1.4Z",
    transform: "translate(-57.322 -140.968)",
    fill: "#4d354d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50451",
    "data-name": "Path 50451",
    d: "M358.016,157.638a.9.9,0,0,1-.751-1.4l3.847-5.83a.9.9,0,0,1,1.5,1l-3.847,5.83A.9.9,0,0,1,358.016,157.638Z",
    transform: "translate(-335.608 -140.968)",
    fill: "#331e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50452",
    "data-name": "Path 50452",
    d: "M241.9,150a.9.9,0,0,0-.9.9v5.48a.9.9,0,0,0,1.807,0V150.9A.9.9,0,0,0,241.9,150Z",
    transform: "translate(-226.487 -140.967)",
    fill: "#4d354d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50453",
    "data-name": "Path 50453",
    d: "M256.9,156.383V150.9a.9.9,0,0,0-.9-.9v7.287A.9.9,0,0,0,256.9,156.383Z",
    transform: "translate(-240.583 -140.967)",
    fill: "#331e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50454",
    "data-name": "Path 50454",
    d: "M96.064,242.852A2.707,2.707,0,0,0,93.493,241H81.645a2.707,2.707,0,0,0-2.571,1.853l-2.3,6.955H98.362Z",
    transform: "translate(-72.153 -226.487)",
    fill: "#fb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50455",
    "data-name": "Path 50455",
    d: "M264.495,242.853A2.706,2.706,0,0,0,261.924,241H256v8.808h10.793Z",
    transform: "translate(-240.583 -226.487)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50456",
    "data-name": "Path 50456",
    d: "M271,277.383h7.78l-1.9-5.766a.9.9,0,0,0-.857-.617H271Z",
    transform: "translate(-254.68 -254.68)",
    fill: "#f3e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50457",
    "data-name": "Path 50457",
    d: "M119.595,271h-5.021a.9.9,0,0,0-.857.617l-1.9,5.766h7.78Z",
    transform: "translate(-105.081 -254.68)",
    fill: "#fff2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50458",
    "data-name": "Path 50458",
    d: "M29.026,336.517l1.716-.9A4.584,4.584,0,0,0,26.256,332H4.577A4.568,4.568,0,0,0,0,336.517v3.613a.9.9,0,0,0,.9.9H29.93a.9.9,0,0,0,.9-.9v-2.71Z",
    transform: "translate(0 -312.007)",
    fill: "#fd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50459",
    "data-name": "Path 50459",
    d: "M271.417,340.13v-2.71l-1.807-.9,1.716-.9A4.584,4.584,0,0,0,266.84,332H256v9.033h14.513A.9.9,0,0,0,271.417,340.13Z",
    transform: "translate(-240.583 -312.007)",
    fill: "#fb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_502",
    "data-name": "Ellipse 502",
    cx: 3.5,
    cy: 2.5,
    rx: 3.5,
    ry: 2.5,
    transform: "translate(12)",
    fill: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50460",
    "data-name": "Path 50460",
    d: "M185.517,90A4.522,4.522,0,0,0,181,94.517a.9.9,0,0,0,.9.9h7.226a.9.9,0,0,0,.9-.9A4.522,4.522,0,0,0,185.517,90Z",
    transform: "translate(-170.1 -84.58)",
    fill: "#fd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50461",
    "data-name": "Path 50461",
    d: "M258.71,2.71A2.713,2.713,0,0,0,256,0V5.42A2.713,2.713,0,0,0,258.71,2.71Z",
    transform: "translate(-240.583)",
    fill: "#fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50462",
    "data-name": "Path 50462",
    d: "M260.517,94.517A4.522,4.522,0,0,0,256,90v5.42h3.613A.9.9,0,0,0,260.517,94.517Z",
    transform: "translate(-240.583 -84.58)",
    fill: "#fb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50463",
    "data-name": "Path 50463",
    d: "M393.71,5.42a2.71,2.71,0,1,1,2.71-2.71A2.713,2.713,0,0,1,393.71,5.42Z",
    transform: "translate(-367.454)",
    fill: "#fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50464",
    "data-name": "Path 50464",
    d: "M369.19,95.42H361.9a.9.9,0,0,1-.9-.9A4.522,4.522,0,0,1,365.517,90a4.574,4.574,0,0,1,4.577,4.517A.9.9,0,0,1,369.19,95.42Z",
    transform: "translate(-339.26 -84.58)",
    fill: "#e64552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50465",
    "data-name": "Path 50465",
    d: "M33.71,5.42a2.71,2.71,0,1,1,2.71-2.71A2.713,2.713,0,0,1,33.71,5.42Z",
    transform: "translate(-29.133)",
    fill: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50466",
    "data-name": "Path 50466",
    d: "M8.19,95.42H.9a.9.9,0,0,1-.9-.9A4.574,4.574,0,0,1,4.577,90a4.522,4.522,0,0,1,4.517,4.517A.9.9,0,0,1,8.19,95.42Z",
    transform: "translate(0 -84.58)",
    fill: "#9af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50467",
    "data-name": "Path 50467",
    d: "M63.71,427.42a2.71,2.71,0,1,1,2.71-2.71A2.713,2.713,0,0,1,63.71,427.42Z",
    transform: "translate(-57.327 -396.587)",
    fill: "#4d354d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50468",
    "data-name": "Path 50468",
    d: "M363.71,427.42a2.71,2.71,0,1,1,2.71-2.71A2.713,2.713,0,0,1,363.71,427.42Z",
    transform: "translate(-339.26 -396.587)",
    fill: "#331e33"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_503",
    "data-name": "Ellipse 503",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(5 27)",
    fill: "#fff2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_504",
    "data-name": "Ellipse 504",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(24 27)",
    fill: "#fff2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50469",
    "data-name": "Path 50469",
    d: "M454.582,392H451.9a.9.9,0,0,0,0,1.807h2.77v-.9A4.532,4.532,0,0,0,454.582,392Z",
    transform: "translate(-423.84 -368.393)",
    fill: "#f93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpool);
export default __webpack_public_path__ + "static/media/carpool.1dd325d5639a4755af486869fb494eb0.svg";
export { ForwardRef as ReactComponent };